import { render, staticRenderFns } from "./GainInsightsHBF.vue?vue&type=template&id=1a578f65&scoped=true"
import script from "./GainInsightsHBF.vue?vue&type=script&lang=js"
export * from "./GainInsightsHBF.vue?vue&type=script&lang=js"
import style0 from "./GainInsightsHBF.vue?vue&type=style&index=0&id=1a578f65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a578f65",
  null
  
)

export default component.exports